import React from 'react';
import { InfoBanner, SuccessBanner } from './call-styles';
import { Close, InfoOutlined, CheckCircleOutlined, Phone } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import { usePhone } from '../../hooks/use-phone';
import { DesktopMessage, DesktopMessagePhoneLocked, useDesktop } from '@revenuewell/logic-desktop';
import { usePhoneWarnings } from '../../hooks/use-phone/use-phone-warning';

export const PhoneInUseBanner: React.FC = () => {
  const { lockDevice } = usePhone();
  const { isLoading, warning: error } = usePhoneWarnings();
  const { isDesktopApplication, isDesktopWidget, listenMessage, sendMessage } = useDesktop();
  const [closed, setClosed] = useState(false);
  const [activating, setActivating] = useState(false);
  const [inUse, setInUse] = useState(false);
  const [inUseDesktop, setInUseDesktop] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (isDesktopApplication()) {
      let interval: any;

      const listenters = [
        listenMessage('desktop-phone-in-use', () => {
          if (!isDesktopWidget) setInUseDesktop(true);
        }),
        listenMessage('desktop-phone-lock', () => {
          if (isDesktopWidget) activatePhone();
        }),
        listenMessage('desktop-phone-locked', (event: DesktopMessage) => {
          const { payload } = event as DesktopMessagePhoneLocked;
          if (!isDesktopWidget) showSuccessMessage(payload?.silent);
        })
      ];

      if (isDesktopWidget) {
        if(inUse) {
          sendMessage({ type: 'desktop-phone-in-use' })
          interval = setInterval(() => sendMessage({ type: 'desktop-phone-in-use' }), 1000);
        } else {
          sendMessage({ type: 'desktop-phone-locked', payload: { silent: true } });
        }
      }

      return () => {
        listenters.forEach((unsubscribe) => unsubscribe());
        if (interval) clearInterval(interval);
      };
    }
  }, [inUse]);

  useEffect(() => {
    if (error !== 'device-in-use' && activating && !closed) showSuccessMessage();
  }, [error, activating, closed]);

  useEffect(() => {
    const isInUse = error === 'device-in-use' && !isLoading && !closed;
    setInUse(isInUse);
    if (!isInUse && isDesktopWidget) sendMessage({ type: 'desktop-phone-locked', payload: { silent: true } });
  }, [error, isLoading, closed]);

  const showSuccessMessage = (silent?: boolean) => {
    if (isDesktopApplication() && isDesktopWidget) sendMessage({ type: 'desktop-phone-locked' });

    setInUseDesktop(false);
    setActivating(false);

    if (silent) return;

    setSuccess(true);
    setTimeout(() => setSuccess(false), 3000);
  };

  const activatePhone = () => {
    if(activating) return;

    setActivating(true);

    if (isDesktopApplication() && !isDesktopWidget) sendMessage({ type: 'desktop-phone-lock' });
    else lockDevice(true);
  };

  if (inUse || inUseDesktop) {
    if (isDesktopApplication() && isDesktopWidget) return null;
    if (isDesktopApplication() && !isDesktopWidget && activating) return null;

    return (
      <InfoBanner icon={<CheckCircleOutlined style={{ fontSize: 22, color: '#0675DD' }} />} severity="info">
        <div style={{ float: 'left', height: '100%', width: '60%', verticalAlign: 'middle' }}>
          <div>
            The WebPhone is currently in use in another session. You may start using it in this session, but it may
            disconnect calls in your other session.
          </div>
        </div>
        <div
          style={{
            float: 'right',
            textAlign: 'left',
            verticalAlign: 'middle',
            height: '100%',
            width: '260px'
          }}
        >
          <div>
            <div
              style={{ float: 'left', width: '230px', cursor: 'pointer', fontSize: '15px', fontWeight: 500 }}
              onClick={() => {
                activatePhone();
              }}
            >
              {activating ? 'Activating' : 'Activate phone in current session'}
            </div>
            {
              !isDesktopApplication() &&
                <div style={{ float: 'right', width: '25px' }} onClick={() => setClosed(true)}>
                  <Close style={{ fontSize: 22, color: '#0675DD' }} />
                </div>
            }
          </div>
        </div>
      </InfoBanner>
    );
  }

  if (success && !closed) {
    if (isDesktopApplication() && isDesktopWidget) return null;

    return (
      <SuccessBanner icon={<InfoOutlined style={{ fontSize: 22, color: '#005E05' }} />} severity="info">
        <div style={{ float: 'left', height: '100%', width: '100%', verticalAlign: 'middle' }}>
          <div>Your calls will now be received in this window</div>
        </div>
      </SuccessBanner>
    );
  }

  return <></>;
};

export default PhoneInUseBanner;
